var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaveLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "c",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 5000 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-.36 832.63s125.63-111.36 284.58-114.69c139.42-2.92 299.33 28.28 427.82 57.58s378.25 98.16 509.2 114.69c118.67 14.98 262.21 19.99 430.59-15.65 180.84-38.27 273.18-60.47 371.15-56.61 129.52 5.11 202.87 40.27 303.27 52.89 116.12 14.6 191.34 12.32 367.38-3.48 179.74-16.13 325.03-24.75 496.46-26.82 202.16-2.45 385.66 23.17 548.11 27.77 148.74 4.22 314.61 4.69 528.23 3.53 231.14-1.25 733.82-1 733.82-1l2.25 213.15H-1.92l1.56-251.37z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveLogin);
export default __webpack_public_path__ + "static/media/waveLogin.0b27eaa58d02c2b519fe01fd2e95845b.svg";
export { ForwardRef as ReactComponent };